'use client';

import type { JSX } from 'react';
import Link from '@alltrails/denali/components/Link';
import InfoDividerDot from '@alltrails/core/components/InfoDividerDot';
import { useExperiments } from '@alltrails/experiments';
import type { Review } from '@alltrails/types/Review';
import type { VoteButtonMode } from '../../types/VoteButtonMode';
import ReviewVoteButton from './ReviewVoteButton';
import styles from './ReviewActionSection.module.scss';

export type ReviewActionSectionProps = {
  review: Review;
  activityLink?: {
    href: string;
    label: React.ReactNode;
    onClick?: () => void;
  };
  voteButtonMode?: VoteButtonMode;
};

const ReviewActionSection = ({ review, activityLink, voteButtonMode = 'hidden' }: ReviewActionSectionProps): JSX.Element | null => {
  const experiments = useExperiments();
  const isUpvoteEnabled = experiments?.['web-disco-review-upvote']?.value === 'on';
  const isReadOnly = voteButtonMode === 'readOnly';
  const upvoteCount = review.votes?.upvoteCount ?? (review as { upvote_count?: number }).upvote_count ?? 0;
  const hasVoteLinks = !!review.votes?.links?.length;
  const showVoteButton = isUpvoteEnabled && voteButtonMode !== 'hidden' && (isReadOnly ? upvoteCount > 0 : hasVoteLinks);

  if (!showVoteButton && !activityLink) {
    return null;
  }

  return (
    <div className={styles.container}>
      {showVoteButton && <ReviewVoteButton review={review} disabled={isReadOnly} readOnly={isReadOnly} />}
      {showVoteButton && activityLink && <InfoDividerDot />}
      {activityLink && (
        <Link href={activityLink.href} target="_blank" onClick={activityLink.onClick} className={styles.activityLink}>
          {activityLink.label}
        </Link>
      )}
    </div>
  );
};

export default ReviewActionSection;
